module.exports = __webpack_public_path__ + "img/logo_portada_crc.497e3c45.png";